import mapsRoutes from '@gral/routes/maps.routes';
import kpisRoutes from '@gral/routes/kpis.routes';
import configRoutes from '@gral/routes/config.routes';
import databaseRoutes from '@gral/routes/database.routes';
import appRoutes from '@gral/routes/app.routes';
import flavorsRoutes from '@gral/routes/flavors.routes';

export default [...appRoutes, ...flavorsRoutes, ...mapsRoutes, ...kpisRoutes, ...configRoutes, ...databaseRoutes];
